import React from 'react';
import { successMetrics } from '../../enhancedMock';

export const SuccessMetrics = () => (
  <section data-testid="success-metrics-section" className="py-10 md:py-16 px-4 bg-primaryOrange text-white relative z-10">
    <div className="container mx-auto">
      <div className="text-center mb-8 md:mb-12">
        <h2 className="text-2xl md:text-4xl font-bold mb-2 md:mb-4">Our Impact</h2>
        <p className="text-base md:text-xl text-white/90">Real Results from Real Patients</p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 text-center">
        <div>
          <div className="text-3xl md:text-5xl font-bold mb-1 md:mb-2">{successMetrics.patientsSatisfaction}</div>
          <p className="text-xs md:text-lg">Patient Satisfaction</p>
        </div>
        <div>
          <div className="text-3xl md:text-5xl font-bold mb-1 md:mb-2">{successMetrics.symptomsImprovement}</div>
          <p className="text-xs md:text-lg">Symptom Improvement</p>
        </div>
        <div>
          <div className="text-3xl md:text-5xl font-bold mb-1 md:mb-2">{successMetrics.wouldRecommend}</div>
          <p className="text-xs md:text-lg">Would Recommend</p>
        </div>
        <div>
          <div className="text-3xl md:text-5xl font-bold mb-1 md:mb-2">{successMetrics.patientsHelped}</div>
          <p className="text-xs md:text-lg">Patients Helped</p>
        </div>
      </div>
    </div>
  </section>
);
